import React from "react";
import s from "./Rectangle.module.css";

const Rectangle = ({ ...props }) => <div className={s.rect} {...props} />;

export default Rectangle;
